import type { IconData } from '@stacksjs/iconify-core'

export const cw1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGbAgIF6xL\"><path fill-opacity=\".7\" d=\"M0 0h9000v9000H0z\"/></clipPath><path id=\"SVGqB82Exhb\" d=\"m0-1l.2.7H1L.3 0l.2.7L0 .4l-.6.4l.2-.7l-.5-.4h.7z\"/></defs><g clip-path=\"url(#SVGbAgIF6xL)\" transform=\"scale(.057)\"><path fill=\"#002b7f\" d=\"M0 0h13500v9000H0z\"/><path fill=\"#f9e814\" d=\"M0 5625h13500v1125H0z\"/><use width=\"13500\" height=\"9000\" x=\"2\" y=\"2\" fill=\"#fff\" href=\"#SVGqB82Exhb\" transform=\"scale(750)\"/><use width=\"13500\" height=\"9000\" x=\"3\" y=\"3\" fill=\"#fff\" href=\"#SVGqB82Exhb\" transform=\"scale(1000)\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cw1x1
